export const formatDate = (lang: string) => {
  const formatUSA = 'YYYY.MM.DD'
  const formatEurope = 'DD.MM.YYYY'

  return lang === 'en' ? formatUSA : formatEurope
}
